<template>
    <div class="support-assistance">
      <h2 class="title">Support & Assistance</h2>
  
      <div class="help-section">
        <h3>Documentation</h3>
        <p>Consulte notre documentation complète pour apprendre à utiliser toutes les fonctionnalités de NoCodeAgent.ai.</p>
        <a href="https://docs.nocodeagent.ai" target="_blank" class="doc-link">Voir la documentation</a>
      </div>
  
      <div class="help-section">
        <h3>FAQ</h3>
        <ul>
          <li><strong>Comment créer un agent IA ?</strong> Utilisez le module "Ajouter un Agent" dans votre tableau de bord.</li>
          <li><strong>Comment intégrer l'agent sur mon site ?</strong> Générez le script dans "Canaux connectés" et collez-le dans votre site.</li>
          <li><strong>Comment changer mon plan ?</strong> Allez dans "Plan & Requêtes" pour mettre à jour votre abonnement.</li>
        </ul>
      </div>
  
      <div class="help-section">
        <h3>Nous contacter</h3>
        <p>Si vous avez d'autres questions ou besoin d'assistance personnalisée, contactez-nous :</p>
        <ul>
          <li>Email : <a href="mailto:support@nocodeagent.ai">support@nocodeagent.ai</a></li>
          <li>Instagram : <a href="https://instagram.com/nocodeagent" target="_blank">@nocodeagent</a></li>
          <li>Twitter/X : <a href="https://x.com/nocodeagent" target="_blank">@nocodeagent</a></li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import Cookies from 'js-cookie'

  export default {
    mounted() {
      const token = Cookies.get('token')
      if (!token) return this.$router.push('/sign-in')
    },
    name: 'SupportAssistance'
  }
  </script>
  
  <style scoped>
  .support-assistance {
    font-family: 'Poppins', sans-serif;
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
  
  .title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 2rem;
    color: #1f2937;
  }
  
  .help-section {
    margin-bottom: 2rem;
  }
  
  .help-section h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.5rem;
  }
  
  .help-section p, .help-section li {
    font-size: 1rem;
    color: #4b5563;
    margin-bottom: 0.5rem;
  }
  
  .doc-link {
    display: inline-block;
    margin-top: 0.5rem;
    color: #6366f1;
    text-decoration: underline;
  }
  </style>